exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "@charset \"UTF-8\";\n/** \n* Пагинация =====================================================\n*/\n/**\n* Хлебные крошки\n*/\n.download-button__link[data-v-2211b686] {\n  display: block;\n}\n.download-button__link .download-button__button[data-v-2211b686] {\n  padding: 21px 24px;\n  font-size: 18px;\n  font-weight: bold;\n  line-height: 1.44;\n  height: auto;\n}\n@media screen and (max-width: 575.98px) {\n.download-button__link .download-button__button[data-v-2211b686] {\n    padding: 12px 15px;\n    font-size: 12px;\n}\n}", ""]);

// exports
